import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const THEME = "#8b1634";

function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function onSiteMinutes(timeOn, timeOff) {
  const toMin = (t) => {
    const m = String(t || "").match(/^(\d{1,2}):(\d{2})/);
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };
  const a = toMin(timeOn);
  const b = toMin(timeOff);
  if (a == null || b == null) return null;
  let d = b - a;
  if (d < 0) d += 24 * 60; // overnight
  return d;
}

const GRID_COLS = "70px 2fr 1fr 1fr 1.1fr 1.1fr 1.3fr";
const TABLE_MIN_WIDTH = "760px";
const headerCell = { fontWeight: "600", color: "#8b1634", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
const cellEllipsis = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
const dataCell = { color: "#2d3748", fontSize: "14px", ...cellEllipsis };

export default function SiteVisitsViewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const visits = Array.isArray(state.visits) ? state.visits : [];
  const siteName = state.siteName || "—";
  const date = state.date || null;
  const workerName = state.workerName || "";

  return (
    <div style={{ padding: "24px" }}>
      <div style={{ background: "#ffffff", borderRadius: "20px", boxShadow: "0px 4px 20px rgba(0,0,0,0.08)", padding: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "24px", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            title="Back"
            style={{ background: THEME, color: "#fff", border: "none", borderRadius: "50%", width: "40px", height: "40px", cursor: "pointer", fontSize: "16px" }}
          >
            <i className="fa fa-arrow-left" />
          </button>
          <div>
            <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#1a202c", margin: 0 }}>Site Visits</h2>
            <div style={{ color: "#64748b", fontSize: "13px", marginTop: "2px" }}>
              {siteName}
              {date ? `  •  ${formatDate(date)}` : ""}
              {workerName ? `  •  ${workerName}` : ""}
            </div>
          </div>
        </div>

        <div style={{ overflowX: "auto", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: GRID_COLS,
              minWidth: TABLE_MIN_WIDTH,
              background: "#e8f4fc",
              padding: "12px 16px",
              borderBottom: "1px solid #e2e8f0",
              gap: "16px",
              alignItems: "center",
            }}
          >
            <div style={headerCell}>#</div>
            <div style={headerCell}>Site</div>
            <div style={headerCell}>Site On</div>
            <div style={headerCell}>Site Off</div>
            <div style={headerCell} title="Travel Time (min)">Travel (min)</div>
            <div style={headerCell} title="On-site (min)">On-site (min)</div>
            <div style={headerCell}>Status</div>
          </div>

          {visits.length === 0 ? (
            <div style={{ padding: "40px", textAlign: "center", color: "#718096", fontSize: "16px" }}>
              No site visits to show.
            </div>
          ) : (
            visits.map((v, i) => {
              const onsite = onSiteMinutes(v.timeOn, v.timeOff);
              return (
                <div
                  key={v._id || i}
                  style={{
                    display: "grid",
                    gridTemplateColumns: GRID_COLS,
                    minWidth: TABLE_MIN_WIDTH,
                    padding: "16px",
                    borderBottom: "1px solid #f1f5f9",
                    gap: "16px",
                    alignItems: "center",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fafafa";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <div style={dataCell}>{i + 1}</div>
                  <div style={dataCell} title={v.siteName || v.siteId || ""}>{v.siteName || v.siteId || "—"}</div>
                  <div style={dataCell}>{v.timeOn || "—"}</div>
                  <div style={dataCell}>{v.timeOff || "—"}</div>
                  <div style={dataCell}>{v.travelTime ?? "—"}</div>
                  <div style={dataCell}>{onsite != null ? onsite : "—"}</div>
                  <div style={cellEllipsis}>
                    {v.status === "confirmed" ? (
                      <span style={{ fontSize: "12px", fontWeight: 700, color: "#1b5e20", background: "#e6f4ea", border: "1px solid #b7dfc2", borderRadius: "6px", padding: "2px 8px" }}>✓ Completed</span>
                    ) : (
                      <span style={{ fontSize: "12px", fontWeight: 600, color: "#92400e", background: "#fef3c7", border: "1px solid #fcd9a3", borderRadius: "6px", padding: "2px 8px" }}>Scheduled</span>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
